/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signinsuccess2Inputs */

const zh_auth_signinsuccess2 = /** @type {(inputs: Auth_Signinsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录成功`)
};

const en_auth_signinsuccess2 = /** @type {(inputs: Auth_Signinsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully signed in`)
};

const es_auth_signinsuccess2 = /** @type {(inputs: Auth_Signinsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesión iniciada correctamente`)
};

/**
* | output |
* | --- |
* | "Successfully signed in" |
*
* @param {Auth_Signinsuccess2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_signinsuccess2 = /** @type {((inputs?: Auth_Signinsuccess2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signinsuccess2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_signinsuccess2(inputs)
	if (locale === "en") return en_auth_signinsuccess2(inputs)
	return es_auth_signinsuccess2(inputs)
});
export { auth_signinsuccess2 as "auth_signInSuccess" }